// extracted by mini-css-extract-plugin
export default {"table-container":"components-settings-users-modals-modal-property-access-module__table-container"};